import { render } from "./resize.vue?vue&type=template&id=917f744c&scoped=true"
import script from "./resize.vue?vue&type=script&lang=js"
export * from "./resize.vue?vue&type=script&lang=js"

import "./resize.vue?vue&type=style&index=0&id=917f744c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917f744c"]])

export default __exports__